import { connect } from 'react-redux'
import { ChangeDefaultPaymentMethodAction, deleteCardAction, deletePaypalAction, fetchCardsAction } from 'store/payment'
import UI from './UI'

const mapStateToProps = ({ payment, currency }) => ({
  cards: payment.creditCards,
  currency: currency.initialCurrency,
  loadingCreditCards: payment.loadingCreditCards
})

const mapDispatchToProps = dispatch => ({
  fetchCards: () => dispatch(fetchCardsAction()),
  changeDefaultPaymentMethodAction: cardId => dispatch(ChangeDefaultPaymentMethodAction(cardId)),
  deleteCard: data => dispatch(deleteCardAction(data)),
  deletePaypal: data => dispatch(deletePaypalAction(data))
})

export default connect(mapStateToProps, mapDispatchToProps)(UI)
